import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {LoginObject} from "../models/login-object.model";
import {Session} from "../models/session.model";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
/**
 * Servicio de autenticación
 */
@Injectable()
export class AuthenticationService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.url;
  }



   login(loginObj: LoginObject): Observable<Session> {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token', 
    }
  
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };


    return this.http.post<Session>(this.url + 'login', loginObj, requestOptions);
  }

  logout(): Observable<Boolean> {    
    return this.http.post<Boolean>(this.url + 'login/logout', {});
  }
}
